import { defineSagaForService } from '@repo/core'
import { postConvenienceTestsConfirm, putConvenienceTestsDraft } from '@repo/user-services'
import { convenienceTestsConfirmActions, convenienceTestsDraftActions } from '../../slices'

export const convenienceTestsDraftMutationsServiceConfig = defineSagaForService({
  [convenienceTestsDraftActions.putRequest.type]: {
    apiClientDomain: 'user',
    service: putConvenienceTestsDraft,
    actionTypeResponse: convenienceTestsDraftActions.putResponse.type,
    actionTypeRequest: convenienceTestsDraftActions.putRequest.type,
  },
  [convenienceTestsConfirmActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: postConvenienceTestsConfirm,
    actionTypeResponse: convenienceTestsConfirmActions.postResponse.type,
    actionTypeRequest: convenienceTestsConfirmActions.postRequest.type,
  },
})
